import { render, staticRenderFns } from "./LibraryForm.vue?vue&type=template&id=1f88c451&"
import script from "./LibraryForm.vue?vue&type=script&lang=js&"
export * from "./LibraryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports